import { formatKennitala } from './formatKennitala';

export function formatPersonDetails(ssn: string, name: string) {
    return `${name}, kt. ${formatKennitala(ssn)}`;
}
